import { render, staticRenderFns } from "./FacebookSidebar.vue?vue&type=template&id=37a23b4f&"
import script from "./FacebookSidebar.vue?vue&type=script&lang=js&"
export * from "./FacebookSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports